unit UFrameFinanceiroFornecedor;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Data.DB, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.Lists, WEBLib.Grids,
  WEBLib.DBCtrls, Vcl.Controls, WEBLib.ExtCtrls, System.StrUtils, Grid.Plugins,
  XData.Web.Client, UUtils, UHelperServer;

type
  TfrmFinanceiroFornecedor = class(TFrame)
    lbPaginationInfoDebitos: TLabel;
    pnlTabelaDebitos: TPanel;
    tblDebitos: TDBTableControl;
    lcPaginatorDebitos: TListControl;
    tblPagamentos: TDBTableControl;
    pnlTabelaPagamentos: TPanel;
    btnPagamentosTab: TButton;
    cdsPagamentos: TXDataWebDataSet;
    dtsPagamentos: TDataSource;
    dtsDebitos: TDataSource;
    cdsDebitos: TXDataWebDataSet;
    cdsDebitosdocumento: TStringField;
    cdsDebitosparcela: TStringField;
    cdsDebitosvalor: TFloatField;
    cdsDebitossaldo: TFloatField;
    cdsDebitospago: TFloatField;
    cdsDebitosemissao: TDateTimeField;
    cdsDebitosvencimento: TDateTimeField;
    cdsPagamentosvalor: TFloatField;
    cdsPagamentosdata: TDateTimeField;
    cdsPagamentosmodalidadenome: TStringField;
    lblDebitosAVencer: TLabel;
    lblDebitosVencidos: TLabel;
    lblTotalDebitos: TLabel;
    lblUltimaCompra: TLabel;
    lblTotalCompras: TLabel;
    lblQuantidadeCompras: TLabel;
    XDataClientResumoFinanceiro: TXDataWebClient;
    cdsPagamentosapagardocumento: TStringField;
    cdsPagamentosapagarparcela: TXDataWebDatasetField;
    procedure cdsDebitosparcelaGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure tblDebitosGetCellClass(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; var AClassName: string);
    procedure tblDebitosGetCellData(Sender: TObject; ACol, ARow: Integer;
      AField: TField; var AValue: string);
    procedure tblPagamentosGetCellClass(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; var AClassName: string);
    procedure btnPagamentosTabClick(Sender: TObject);
    procedure XDataClientResumoFinanceiroError(Error: TXDataClientError);
    procedure XDataClientResumoFinanceiroLoad(Response: TXDataClientResponse);
    procedure cdsDebitosdocumentoGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure cdsPagamentosapagardocumentoGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
  private
    FFornecedorId : string;
    FGridPluginDebitos : TGridPlugin;

    procedure CarregarDebitos;
  public
    procedure CarregarInformacoesIniciais(pFornecedorId : string);
  protected procedure LoadDFMValues; override; end;

var
  frmFinanceiroFornecedor: TfrmFinanceiroFornecedor;

implementation

uses
  ConnectionModule;

{$R *.dfm}

procedure TfrmFinanceiroFornecedor.btnPagamentosTabClick(Sender: TObject);
begin
  if cdsPagamentos.Tag = 0 then
  begin
    cdsPagamentos.Close;
    cdsPagamentos.Tag := 1;
    cdsPagamentos.QueryString := '$filter=(apagar/fornecedor_id eq ' + FFornecedorId +
      ')&$orderby=data desc, codigo_interno desc&$expand=modalidade, apagar';
    cdsPagamentos.Load;
  end;
end;

procedure TfrmFinanceiroFornecedor.CarregarDebitos;
begin
  if cdsDebitos.Tag = 0 then
  begin
    cdsDebitos.Tag := 1;

    FGridPluginDebitos := TGridPlugin.Create(tblDebitos, cdsDebitos, lcPaginatorDebitos, lbPaginationInfoDebitos);
    FGridPluginDebitos.FDatasetPlugin.FFilterPadrao := '(fornecedor_id eq ' + FFornecedorId +
      ') and (SALDO gt 0)';
    FGridPluginDebitos.FDatasetPlugin.FOrderByPadrao := 'vencimento asc';
    FGridPluginDebitos.SetPageSize(10);
    FGridPluginDebitos.SetFilterText(EmptyStr);
    FGridPluginDebitos.Load;
  end;
end;

procedure TfrmFinanceiroFornecedor.CarregarInformacoesIniciais(
  pFornecedorId: string);
begin
  FFornecedorId := pFornecedorId;
  XDataClientResumoFinanceiro.RawInvoke('IService.GetFinanceiroFornecedor', [pFornecedorId]);
end;

procedure TfrmFinanceiroFornecedor.cdsDebitosdocumentoGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := THelperServer.FormatarDocumento(Sender.AsString, cdsDebitos.FieldByName('parcela').AsInteger);
end;

procedure TfrmFinanceiroFornecedor.cdsDebitosparcelaGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := Format('%.3d', [Sender.AsInteger]);
end;

procedure TfrmFinanceiroFornecedor.cdsPagamentosapagardocumentoGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := THelperServer.FormatarDocumento(Sender.AsString, cdsPagamentos.FieldByName('apagar.parcela').AsInteger);
end;

procedure TfrmFinanceiroFornecedor.tblDebitosGetCellClass(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(tblDebitos.Columns[ACol].DataField, ['valor', 'saldo', 'pago', 'documento']) of
      0, 1, 2: AClassName := 'text-end';
      4: AClassName := 'text-start';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TfrmFinanceiroFornecedor.tblDebitosGetCellData(Sender: TObject; ACol,
  ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    if StrToDate(tblDebitos.DataSource.DataSet.FieldByName('vencimento').AsString) < Date then
      AValue := '<p class="text-danger">' + AValue + '</p>'
  end;
end;

procedure TfrmFinanceiroFornecedor.tblPagamentosGetCellClass(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if cdsPagamentos.Tag = 0 then
    Exit;

  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(tblPagamentos.Columns[ACol].DataField, ['valor', 'modalidade.nome',
      'apagar.documento']) of
      0: AClassName := 'text-end';
      1, 2: AClassName := 'text-start';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TfrmFinanceiroFornecedor.XDataClientResumoFinanceiroError(
  Error: TXDataClientError);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, Error.ErrorMessage);
  CarregarDebitos;
end;

procedure TfrmFinanceiroFornecedor.XDataClientResumoFinanceiroLoad(
  Response: TXDataClientResponse);
var
  lTotalDebitos,
  lDebitosAVencer,
  lDebitosVencidos,
  lTotalCompras : Currency;
  lUltimaCompra : string;
begin
  lDebitosAVencer := StrToCurr(StringReplace(string(TJSObject(Response.Result)['total_debitos_avencer']),
      '.', ',', []));
  lDebitosVencidos := StrToCurr(StringReplace(string(TJSObject(Response.Result)['total_debitos_vencidos']),
      '.', ',', []));
  lTotalCompras := StrToCurr(StringReplace(string(TJSObject(Response.Result)['total_compras']),
      '.', ',', []));

  lTotalDebitos := lDebitosAVencer + lDebitosVencidos;

  lUltimaCompra := string(TJSObject(Response.Result)['ultima_compra']);

  if lUltimaCompra.ToUpper = 'NULL' then
    lUltimaCompra := ' - ';

  lblDebitosAVencer.Caption := FormatFloat('#,##0.00', lDebitosAVencer);
  lblDebitosVencidos.Caption := FormatFloat('#,##0.00', lDebitosVencidos);
  lblTotalDebitos.Caption := FormatFloat('#,##0.00', lTotalDebitos);
  lblUltimaCompra.Caption := lUltimaCompra;
  lblTotalCompras.Caption := FormatFloat('#,##0.00', lTotalCompras);
  lblQuantidadeCompras.Caption := TUtils.FormatarNumeroInteiro(Integer(TJSObject(Response.Result)['quantidade_compras']));

  CarregarDebitos;
end;

procedure TfrmFinanceiroFornecedor.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfoDebitos := TLabel.Create('lbPaginationInfoDebitos');
  lblDebitosAVencer := TLabel.Create('lblDebitosAVencer');
  lblDebitosVencidos := TLabel.Create('lblDebitosVencidos');
  lblTotalDebitos := TLabel.Create('lblTotalDebitos');
  lblUltimaCompra := TLabel.Create('lblUltimaCompra');
  lblTotalCompras := TLabel.Create('lblTotalCompras');
  lblQuantidadeCompras := TLabel.Create('lblQuantidadeCompras');
  pnlTabelaDebitos := TPanel.Create(Self);
  tblDebitos := TDBTableControl.Create('tblDebitos');
  lcPaginatorDebitos := TListControl.Create('lcPaginatorDebitos');
  tblPagamentos := TDBTableControl.Create('tblPagamentos');
  pnlTabelaPagamentos := TPanel.Create(Self);
  btnPagamentosTab := TButton.Create('line-pagamentos-tab');
  cdsPagamentos := TXDataWebDataSet.Create(Self);
  cdsPagamentosvalor := TFloatField.Create(Self);
  cdsPagamentosdata := TDateTimeField.Create(Self);
  cdsPagamentosmodalidadenome := TStringField.Create(Self);
  cdsPagamentosapagardocumento := TStringField.Create(Self);
  cdsPagamentosapagarparcela := TXDataWebDatasetField.Create(Self);
  dtsPagamentos := TDataSource.Create(Self);
  dtsDebitos := TDataSource.Create(Self);
  cdsDebitos := TXDataWebDataSet.Create(Self);
  cdsDebitosdocumento := TStringField.Create(Self);
  cdsDebitosparcela := TStringField.Create(Self);
  cdsDebitosvalor := TFloatField.Create(Self);
  cdsDebitossaldo := TFloatField.Create(Self);
  cdsDebitospago := TFloatField.Create(Self);
  cdsDebitosemissao := TDateTimeField.Create(Self);
  cdsDebitosvencimento := TDateTimeField.Create(Self);
  XDataClientResumoFinanceiro := TXDataWebClient.Create(Self);

  lbPaginationInfoDebitos.BeforeLoadDFMValues;
  lblDebitosAVencer.BeforeLoadDFMValues;
  lblDebitosVencidos.BeforeLoadDFMValues;
  lblTotalDebitos.BeforeLoadDFMValues;
  lblUltimaCompra.BeforeLoadDFMValues;
  lblTotalCompras.BeforeLoadDFMValues;
  lblQuantidadeCompras.BeforeLoadDFMValues;
  pnlTabelaDebitos.BeforeLoadDFMValues;
  tblDebitos.BeforeLoadDFMValues;
  lcPaginatorDebitos.BeforeLoadDFMValues;
  tblPagamentos.BeforeLoadDFMValues;
  pnlTabelaPagamentos.BeforeLoadDFMValues;
  btnPagamentosTab.BeforeLoadDFMValues;
  cdsPagamentos.BeforeLoadDFMValues;
  cdsPagamentosvalor.BeforeLoadDFMValues;
  cdsPagamentosdata.BeforeLoadDFMValues;
  cdsPagamentosmodalidadenome.BeforeLoadDFMValues;
  cdsPagamentosapagardocumento.BeforeLoadDFMValues;
  cdsPagamentosapagarparcela.BeforeLoadDFMValues;
  dtsPagamentos.BeforeLoadDFMValues;
  dtsDebitos.BeforeLoadDFMValues;
  cdsDebitos.BeforeLoadDFMValues;
  cdsDebitosdocumento.BeforeLoadDFMValues;
  cdsDebitosparcela.BeforeLoadDFMValues;
  cdsDebitosvalor.BeforeLoadDFMValues;
  cdsDebitossaldo.BeforeLoadDFMValues;
  cdsDebitospago.BeforeLoadDFMValues;
  cdsDebitosemissao.BeforeLoadDFMValues;
  cdsDebitosvencimento.BeforeLoadDFMValues;
  XDataClientResumoFinanceiro.BeforeLoadDFMValues;
  try
    Name := 'frmFinanceiroFornecedor';
    Left := 0;
    Top := 0;
    Width := 564;
    Height := 253;
    TabOrder := 0;
    lbPaginationInfoDebitos.SetParentComponent(Self);
    lbPaginationInfoDebitos.Name := 'lbPaginationInfoDebitos';
    lbPaginationInfoDebitos.Left := 6;
    lbPaginationInfoDebitos.Top := 127;
    lbPaginationInfoDebitos.Width := 151;
    lbPaginationInfoDebitos.Height := 15;
    lbPaginationInfoDebitos.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfoDebitos.Color := clBtnFace;
    lbPaginationInfoDebitos.HeightPercent := 100.000000000000000000;
    lbPaginationInfoDebitos.WidthPercent := 100.000000000000000000;
    lblDebitosAVencer.SetParentComponent(Self);
    lblDebitosAVencer.Name := 'lblDebitosAVencer';
    lblDebitosAVencer.Left := 144;
    lblDebitosAVencer.Top := 176;
    lblDebitosAVencer.Width := 5;
    lblDebitosAVencer.Height := 15;
    lblDebitosAVencer.Caption := '-';
    lblDebitosAVencer.Color := clBtnFace;
    lblDebitosAVencer.HeightPercent := 100.000000000000000000;
    lblDebitosAVencer.WidthPercent := 100.000000000000000000;
    lblDebitosVencidos.SetParentComponent(Self);
    lblDebitosVencidos.Name := 'lblDebitosVencidos';
    lblDebitosVencidos.Left := 144;
    lblDebitosVencidos.Top := 196;
    lblDebitosVencidos.Width := 5;
    lblDebitosVencidos.Height := 15;
    lblDebitosVencidos.Caption := '-';
    lblDebitosVencidos.Color := clBtnFace;
    lblDebitosVencidos.HeightPercent := 100.000000000000000000;
    lblDebitosVencidos.WidthPercent := 100.000000000000000000;
    lblTotalDebitos.SetParentComponent(Self);
    lblTotalDebitos.Name := 'lblTotalDebitos';
    lblTotalDebitos.Left := 144;
    lblTotalDebitos.Top := 217;
    lblTotalDebitos.Width := 5;
    lblTotalDebitos.Height := 15;
    lblTotalDebitos.Caption := '-';
    lblTotalDebitos.Color := clBtnFace;
    lblTotalDebitos.HeightPercent := 100.000000000000000000;
    lblTotalDebitos.WidthPercent := 100.000000000000000000;
    lblUltimaCompra.SetParentComponent(Self);
    lblUltimaCompra.Name := 'lblUltimaCompra';
    lblUltimaCompra.Left := 272;
    lblUltimaCompra.Top := 176;
    lblUltimaCompra.Width := 5;
    lblUltimaCompra.Height := 15;
    lblUltimaCompra.Caption := '-';
    lblUltimaCompra.Color := clBtnFace;
    lblUltimaCompra.HeightPercent := 100.000000000000000000;
    lblUltimaCompra.WidthPercent := 100.000000000000000000;
    lblTotalCompras.SetParentComponent(Self);
    lblTotalCompras.Name := 'lblTotalCompras';
    lblTotalCompras.Left := 272;
    lblTotalCompras.Top := 197;
    lblTotalCompras.Width := 5;
    lblTotalCompras.Height := 15;
    lblTotalCompras.Caption := '-';
    lblTotalCompras.Color := clBtnFace;
    lblTotalCompras.HeightPercent := 100.000000000000000000;
    lblTotalCompras.WidthPercent := 100.000000000000000000;
    lblQuantidadeCompras.SetParentComponent(Self);
    lblQuantidadeCompras.Name := 'lblQuantidadeCompras';
    lblQuantidadeCompras.Left := 272;
    lblQuantidadeCompras.Top := 217;
    lblQuantidadeCompras.Width := 5;
    lblQuantidadeCompras.Height := 15;
    lblQuantidadeCompras.Caption := '-';
    lblQuantidadeCompras.Color := clBtnFace;
    lblQuantidadeCompras.HeightPercent := 100.000000000000000000;
    lblQuantidadeCompras.WidthPercent := 100.000000000000000000;
    pnlTabelaDebitos.SetParentComponent(Self);
    pnlTabelaDebitos.Name := 'pnlTabelaDebitos';
    pnlTabelaDebitos.Left := 3;
    pnlTabelaDebitos.Top := 3;
    pnlTabelaDebitos.Width := 275;
    pnlTabelaDebitos.Height := 17;
    pnlTabelaDebitos.Caption := 'Espa'#231'o D'#233'bitos';
    pnlTabelaDebitos.ChildOrder := 23;
    pnlTabelaDebitos.Color := clInfoText;
    pnlTabelaDebitos.Font.Charset := DEFAULT_CHARSET;
    pnlTabelaDebitos.Font.Color := clWhite;
    pnlTabelaDebitos.Font.Height := -11;
    pnlTabelaDebitos.Font.Name := 'Tahoma';
    pnlTabelaDebitos.Font.Style := [fsBold];
    pnlTabelaDebitos.ParentFont := False;
    pnlTabelaDebitos.TabOrder := 0;
    pnlTabelaDebitos.Visible := False;
    tblDebitos.SetParentComponent(Self);
    tblDebitos.Name := 'tblDebitos';
    tblDebitos.Left := 3;
    tblDebitos.Top := 24;
    tblDebitos.Width := 275;
    tblDebitos.Height := 97;
    tblDebitos.ElementClassName := 'table-responsive';
    tblDebitos.BorderColor := clSilver;
    tblDebitos.ChildOrder := 82;
    tblDebitos.ColHeader := False;
    tblDebitos.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblDebitos, Self, 'OnGetCellData', 'tblDebitosGetCellData');
    SetEvent(tblDebitos, Self, 'OnGetCellClass', 'tblDebitosGetCellClass');
    tblDebitos.Columns.Clear;
    with tblDebitos.Columns.Add do
    begin
      DataField := 'documento';
      Title := 'Doc./Parcela';
    end;
    with tblDebitos.Columns.Add do
    begin
      DataField := 'emissao';
      Title := 'Emiss'#227'o';
    end;
    with tblDebitos.Columns.Add do
    begin
      DataField := 'vencimento';
      Title := 'Vencimento';
    end;
    with tblDebitos.Columns.Add do
    begin
      DataField := 'saldo';
      Title := 'Saldo Pendente';
    end;
    with tblDebitos.Columns.Add do
    begin
      DataField := 'pago';
      Title := 'Valor Pago';
    end;
    with tblDebitos.Columns.Add do
    begin
      DataField := 'valor';
      Title := 'Valor Total';
    end;
    tblDebitos.DataSource := dtsDebitos;
    lcPaginatorDebitos.SetParentComponent(Self);
    lcPaginatorDebitos.Name := 'lcPaginatorDebitos';
    lcPaginatorDebitos.Left := 176;
    lcPaginatorDebitos.Top := 127;
    lcPaginatorDebitos.Width := 102;
    lcPaginatorDebitos.Height := 15;
    lcPaginatorDebitos.HeightPercent := 100.000000000000000000;
    lcPaginatorDebitos.WidthPercent := 100.000000000000000000;
    lcPaginatorDebitos.ChildOrder := 81;
    lcPaginatorDebitos.DefaultItemClassName := 'page-item';
    lcPaginatorDebitos.DefaultItemLinkClassName := 'page-link';
    lcPaginatorDebitos.ElementListClassName := 'pagination';
    lcPaginatorDebitos.Items.Clear;
    with lcPaginatorDebitos.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with lcPaginatorDebitos.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with lcPaginatorDebitos.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    lcPaginatorDebitos.Style := lsPagination;
    tblPagamentos.SetParentComponent(Self);
    tblPagamentos.Name := 'tblPagamentos';
    tblPagamentos.Left := 286;
    tblPagamentos.Top := 24;
    tblPagamentos.Width := 275;
    tblPagamentos.Height := 97;
    tblPagamentos.ElementClassName := 'table-responsive';
    tblPagamentos.BorderColor := clSilver;
    tblPagamentos.ChildOrder := 82;
    tblPagamentos.ColHeader := False;
    tblPagamentos.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblPagamentos, Self, 'OnGetCellClass', 'tblPagamentosGetCellClass');
    tblPagamentos.Columns.Clear;
    with tblPagamentos.Columns.Add do
    begin
      DataField := 'apagar.documento';
      Title := 'Doc./Parcela';
    end;
    with tblPagamentos.Columns.Add do
    begin
      DataField := 'modalidade.nome';
      Title := 'Modalidade';
    end;
    with tblPagamentos.Columns.Add do
    begin
      DataField := 'data';
      Title := 'Data Pagamento';
    end;
    with tblPagamentos.Columns.Add do
    begin
      DataField := 'valor';
      Title := 'Valor';
    end;
    tblPagamentos.DataSource := dtsPagamentos;
    pnlTabelaPagamentos.SetParentComponent(Self);
    pnlTabelaPagamentos.Name := 'pnlTabelaPagamentos';
    pnlTabelaPagamentos.Left := 286;
    pnlTabelaPagamentos.Top := 3;
    pnlTabelaPagamentos.Width := 275;
    pnlTabelaPagamentos.Height := 17;
    pnlTabelaPagamentos.Caption := 'Espa'#231'o Pagamentos';
    pnlTabelaPagamentos.ChildOrder := 23;
    pnlTabelaPagamentos.Color := clInfoText;
    pnlTabelaPagamentos.Font.Charset := DEFAULT_CHARSET;
    pnlTabelaPagamentos.Font.Color := clWhite;
    pnlTabelaPagamentos.Font.Height := -11;
    pnlTabelaPagamentos.Font.Name := 'Tahoma';
    pnlTabelaPagamentos.Font.Style := [fsBold];
    pnlTabelaPagamentos.ParentFont := False;
    pnlTabelaPagamentos.TabOrder := 4;
    pnlTabelaPagamentos.Visible := False;
    btnPagamentosTab.SetParentComponent(Self);
    btnPagamentosTab.Name := 'btnPagamentosTab';
    btnPagamentosTab.Left := 6;
    btnPagamentosTab.Top := 148;
    btnPagamentosTab.Width := 96;
    btnPagamentosTab.Height := 25;
    btnPagamentosTab.Caption := #218'ltimos (10) Pagamentos';
    btnPagamentosTab.ChildOrder := 16;
    btnPagamentosTab.HeightPercent := 100.000000000000000000;
    btnPagamentosTab.TabStop := False;
    btnPagamentosTab.WidthPercent := 100.000000000000000000;
    SetEvent(btnPagamentosTab, Self, 'OnClick', 'btnPagamentosTabClick');
    cdsPagamentos.SetParentComponent(Self);
    cdsPagamentos.Name := 'cdsPagamentos';
    cdsPagamentos.EntitySetName := 'Pagamentos';
    cdsPagamentos.Connection := DMConnection.ApiConnection;
    cdsPagamentos.QueryTop := 10;
    cdsPagamentos.Left := 355;
    cdsPagamentos.Top := 44;
    cdsPagamentosvalor.SetParentComponent(cdsPagamentos);
    cdsPagamentosvalor.Name := 'cdsPagamentosvalor';
    cdsPagamentosvalor.FieldName := 'valor';
    cdsPagamentosvalor.DisplayFormat := '#,##0.00';
    cdsPagamentosdata.SetParentComponent(cdsPagamentos);
    cdsPagamentosdata.Name := 'cdsPagamentosdata';
    cdsPagamentosdata.FieldName := 'data';
    cdsPagamentosdata.DisplayFormat := 'dd/mm/yy';
    cdsPagamentosmodalidadenome.SetParentComponent(cdsPagamentos);
    cdsPagamentosmodalidadenome.Name := 'cdsPagamentosmodalidadenome';
    cdsPagamentosmodalidadenome.FieldName := 'modalidade.nome';
    cdsPagamentosapagardocumento.SetParentComponent(cdsPagamentos);
    cdsPagamentosapagardocumento.Name := 'cdsPagamentosapagardocumento';
    cdsPagamentosapagardocumento.FieldName := 'apagar.documento';
    SetEvent(cdsPagamentosapagardocumento, Self, 'OnGetText', 'cdsPagamentosapagardocumentoGetText');
    cdsPagamentosapagarparcela.SetParentComponent(cdsPagamentos);
    cdsPagamentosapagarparcela.Name := 'cdsPagamentosapagarparcela';
    cdsPagamentosapagarparcela.FieldName := 'apagar.parcela';
    dtsPagamentos.SetParentComponent(Self);
    dtsPagamentos.Name := 'dtsPagamentos';
    dtsPagamentos.DataSet := cdsPagamentos;
    dtsPagamentos.Left := 459;
    dtsPagamentos.Top := 36;
    dtsDebitos.SetParentComponent(Self);
    dtsDebitos.Name := 'dtsDebitos';
    dtsDebitos.DataSet := cdsDebitos;
    dtsDebitos.Left := 144;
    dtsDebitos.Top := 58;
    cdsDebitos.SetParentComponent(Self);
    cdsDebitos.Name := 'cdsDebitos';
    cdsDebitos.EntitySetName := 'Apagar';
    cdsDebitos.Connection := DMConnection.ApiConnection;
    cdsDebitos.Left := 72;
    cdsDebitos.Top := 58;
    cdsDebitosdocumento.SetParentComponent(cdsDebitos);
    cdsDebitosdocumento.Name := 'cdsDebitosdocumento';
    cdsDebitosdocumento.FieldName := 'documento';
    SetEvent(cdsDebitosdocumento, Self, 'OnGetText', 'cdsDebitosdocumentoGetText');
    cdsDebitosdocumento.Size := 255;
    cdsDebitosparcela.SetParentComponent(cdsDebitos);
    cdsDebitosparcela.Name := 'cdsDebitosparcela';
    cdsDebitosparcela.FieldName := 'parcela';
    SetEvent(cdsDebitosparcela, Self, 'OnGetText', 'cdsDebitosparcelaGetText');
    cdsDebitosparcela.Size := 255;
    cdsDebitosvalor.SetParentComponent(cdsDebitos);
    cdsDebitosvalor.Name := 'cdsDebitosvalor';
    cdsDebitosvalor.FieldName := 'valor';
    cdsDebitosvalor.Required := True;
    cdsDebitosvalor.DisplayFormat := '#,##0.00';
    cdsDebitossaldo.SetParentComponent(cdsDebitos);
    cdsDebitossaldo.Name := 'cdsDebitossaldo';
    cdsDebitossaldo.FieldName := 'saldo';
    cdsDebitossaldo.DisplayFormat := '#,##0.00';
    cdsDebitospago.SetParentComponent(cdsDebitos);
    cdsDebitospago.Name := 'cdsDebitospago';
    cdsDebitospago.FieldName := 'pago';
    cdsDebitospago.DisplayFormat := '#,##0.00';
    cdsDebitosemissao.SetParentComponent(cdsDebitos);
    cdsDebitosemissao.Name := 'cdsDebitosemissao';
    cdsDebitosemissao.FieldName := 'emissao';
    cdsDebitosemissao.DisplayFormat := 'dd/mm/yy';
    cdsDebitosvencimento.SetParentComponent(cdsDebitos);
    cdsDebitosvencimento.Name := 'cdsDebitosvencimento';
    cdsDebitosvencimento.FieldName := 'vencimento';
    cdsDebitosvencimento.Required := True;
    cdsDebitosvencimento.DisplayFormat := 'dd/mm/yy';
    XDataClientResumoFinanceiro.SetParentComponent(Self);
    XDataClientResumoFinanceiro.Name := 'XDataClientResumoFinanceiro';
    XDataClientResumoFinanceiro.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientResumoFinanceiro, Self, 'OnLoad', 'XDataClientResumoFinanceiroLoad');
    SetEvent(XDataClientResumoFinanceiro, Self, 'OnError', 'XDataClientResumoFinanceiroError');
    XDataClientResumoFinanceiro.Left := 40;
    XDataClientResumoFinanceiro.Top := 182;
  finally
    lbPaginationInfoDebitos.AfterLoadDFMValues;
    lblDebitosAVencer.AfterLoadDFMValues;
    lblDebitosVencidos.AfterLoadDFMValues;
    lblTotalDebitos.AfterLoadDFMValues;
    lblUltimaCompra.AfterLoadDFMValues;
    lblTotalCompras.AfterLoadDFMValues;
    lblQuantidadeCompras.AfterLoadDFMValues;
    pnlTabelaDebitos.AfterLoadDFMValues;
    tblDebitos.AfterLoadDFMValues;
    lcPaginatorDebitos.AfterLoadDFMValues;
    tblPagamentos.AfterLoadDFMValues;
    pnlTabelaPagamentos.AfterLoadDFMValues;
    btnPagamentosTab.AfterLoadDFMValues;
    cdsPagamentos.AfterLoadDFMValues;
    cdsPagamentosvalor.AfterLoadDFMValues;
    cdsPagamentosdata.AfterLoadDFMValues;
    cdsPagamentosmodalidadenome.AfterLoadDFMValues;
    cdsPagamentosapagardocumento.AfterLoadDFMValues;
    cdsPagamentosapagarparcela.AfterLoadDFMValues;
    dtsPagamentos.AfterLoadDFMValues;
    dtsDebitos.AfterLoadDFMValues;
    cdsDebitos.AfterLoadDFMValues;
    cdsDebitosdocumento.AfterLoadDFMValues;
    cdsDebitosparcela.AfterLoadDFMValues;
    cdsDebitosvalor.AfterLoadDFMValues;
    cdsDebitossaldo.AfterLoadDFMValues;
    cdsDebitospago.AfterLoadDFMValues;
    cdsDebitosemissao.AfterLoadDFMValues;
    cdsDebitosvencimento.AfterLoadDFMValues;
    XDataClientResumoFinanceiro.AfterLoadDFMValues;
  end;
end;

end.